/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CanTableBeFreeDto as DigiworkMaitreDPosDtoGroupCanTableBeFreeDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Group/can-table-be-free-dto';

export interface TableHasBills$Params {
  tableId: string;
  venueId?: string;
}

export function tableHasBills(http: HttpClient, rootUrl: string, params: TableHasBills$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupCanTableBeFreeDto>> {
  const rb = new RequestBuilder(rootUrl, tableHasBills.PATH, 'get');
  if (params) {
    rb.path('tableId', params.tableId, {});
    rb.query('venueId', params.venueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoGroupCanTableBeFreeDto>;
    })
  );
}

tableHasBills.PATH = '/api/groups/layouts/tables/{tableId}';
